import React from 'react'
import { Container } from '@shared/components/container'
import { Image } from '@shared/components/image'

import styles from './style.module.scss'

export const OurManagers = () => {
	return (
		<Container className='mt-xl mb-xl'>
			<h2>Наши специалисты</h2>
			<div className={styles.managers}>
				<div className={styles.manager}>
					<div className={styles.managerPhoto}>
						<Image name='manager1_mini.jpg' />
					</div>
					<div>
						<h3>Владимир Холодилов</h3>
						<div className='mt-xs'>
							<h4>Руководитель отдела по работе с клиентами Credit.Club</h4>
						</div>
					</div>
				</div>
				<div className={styles.manager}>
					<div className={styles.managerPhoto}>
						<Image name='lika.png' />
					</div>
					<div>
						<h3>Лика Аксентьева</h3>
						<div className='mt-xs'>
							<h4>Менеджер по работе с клиентами Credit.Club</h4>
						</div>
					</div>
				</div>
			</div>
		</Container>
	)
}
